import { render, staticRenderFns } from "./login.component.vue?vue&type=template&id=276f51c2&scoped=true&"
import script from "./login.component.vue?vue&type=script&lang=ts&"
export * from "./login.component.vue?vue&type=script&lang=ts&"
import style0 from "./login.component.vue?vue&type=style&index=0&id=276f51c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276f51c2",
  null
  
)

export default component.exports